import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { disableBodyScrolling } from '@/utils/disableBodyScrolling';

@Component
export class SideCart extends ThemeComponent {
    @Prop({default: window.scrollY}) scrollPosition!: number;

    @Ref() sidecartClose!: HTMLDivElement;

    init() {
        // Give initial value for scrollPosition
        this.scrollPosition = window.scrollY;

        this.eventListeners();
    }

    eventListeners() {
        this.openCart();
        this.closeCart();
        this.closeEvent();
    }

    openCart() {
        document.addEventListener('cartOpen', () => {

            //Update Cart
            document.dispatchEvent(new Event('cartChanged'));

            // Add active class
            this.classList.add('side-cart--active');
            const elements = document.querySelectorAll('.product-card-quick-add');
            for (const element of elements) {
                element.classList.remove('is-active');
            }
            // disable body scrolling
            this.scrollPosition = disableBodyScrolling(true, this.scrollPosition);
        });
    }

    closeCart() {
        document.addEventListener('cartClosed', () => {

            // Remove active class
            this.classList.remove('side-cart--active');

            // Enable body scrolling
            this.scrollPosition = disableBodyScrolling(false, this.scrollPosition);
        });
    }

    closeEvent() {
        this.$listen(this.sidecartClose, 'click', (event) => {
            document.dispatchEvent(new Event('cartClosed'));
        });

        this.$listen(this, 'click', (event) => {
            if (event.target) {
                const clikedElement = event.target as HTMLElement;
                if (clikedElement.tagName === 'SIDE-CART') {
                    document.dispatchEvent(new Event('cartClosed'));
                }
            }
        });
    }
}
